<template>
  <div class="table_wrap">
    <div class="pagnation_wrap home-pagebar">
      <div class="inline-block" v-if="paginationData.total > 0">
<!--        <el-button class="search-button item-delete" size="small" @click="boardListDelete()" >선택항목 삭제</el-button>-->
        <el-button class="pagebar-button" icon="el-icon-d-arrow-left" :disabled="page === 1" @click="changePage('page',page=1)"></el-button>
        <el-button class="pagebar-button" icon="el-icon-arrow-left" :disabled="page === 1" @click="changePage('page',page-1)"></el-button>
        <el-pagination
            :page-size="paginationData.size"
            :current-page.sync="page"
            :pager-count="11"
            :total="paginationData.total"
            @current-change="changePage('page', page)"
            class="bottom-pagebar"
            layout="pager"
            background>
        </el-pagination>
        <el-button class="pagebar-button" icon="el-icon-arrow-right" :disabled="page === returnLastPage()" @click="changePage('page',page+1)"></el-button>
        <el-button class="pagebar-button" icon="el-icon-d-arrow-right" :disabled="page === returnLastPage()" @click="changePage('page',page=returnLastPage())"></el-button>
      </div>
    </div>
  </div>
</template>

<script>
import util from "@/mixins/util";
export default {
  name: "PaginationDefaultLayout",
  mixins: [],
  components: {},
  inject: {
    setPage: {default: () => {}},
    boardListDelete: { default: () => {}},

  },
  provide() {
    return {}
  },
  props: {
    paginationData: {
      type: Object,
      default: {
        total: 0,
        page: 0,
        size: 0,
      }
    },
    listLength: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      page: 1,
      size: 10,
      sizeList: [10, 30, 50]
    }
  },
  created() {},
  mounted() {
    this.page = this.paginationData.page;
    this.size = this.paginationData.size;
  },
  beforeDestroy() {},
  destroyed() {},
  computed: {
  },
  methods: {
    changePage(key, value) {
      this.setPage(key, value);
    },
    returnLastPage() {
      return Math.ceil(this.paginationData.total/this.paginationData.size);
    },
  },
  watch: {
    'paginationData.page': {
      deep: true,
      handler: function (val, oldVal) {
        this.page = this.paginationData.page;
      }
    }
  },
}
</script>

<style scoped>

</style>
